// client/src/components/layout/Footer.js
import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { getViewportPreference, setViewportPreference } from '../../utils/ViewportManager';
import './Footer.css'; // This will now point to the updated CSS

const Footer = () => {
  const [viewportMode, setViewportMode] = useState(getViewportPreference);

  useEffect(() => {
    const handleSync = (e) => {
      setViewportMode(e.detail || getViewportPreference());
    };
    window.addEventListener('makah:viewport-mode-changed', handleSync);
    return () => window.removeEventListener('makah:viewport-mode-changed', handleSync);
  }, []);

  const toggleViewMode = () => {
    const nextMode = viewportMode === 'desktop' ? 'auto' : 'desktop';
    setViewportPreference(nextMode);
    setViewportMode(nextMode);
  };
  return (
    <footer className="site-footer">
      <div className="container">
        {/* --- The Main Three-Tile Section --- */}
        <div className="footer-main-content">
          <div className="footer-column">
            <h3>Our Mission</h3>
            <p>
              To empower healthcare providers in Tanzania with access to superior
              quality medical equipment, reliable supplies, and exceptional
              maintenance services, fostering a healthier and more capable medical
              landscape.
            </p>
          </div>

          <div className="footer-column">
            <h3>Our Vision</h3>
            <p>
              To be the leading and most trusted provider of comprehensive
              medical equipment and support solutions in Tanzania, setting
              benchmarks for quality, innovation, and client partnership across
              the East African region.
            </p>
          </div>

          <div className="footer-column contact-details-column">
            <h3>Contact Details</h3>
            <div className="contact-info-item-footer">
              <i className="fas fa-map-marker-alt"></i>
              <span>Mbuyuni, Salasala Road, Kinondoni, Dar es Salaam</span>
            </div>
            <div className="contact-info-item-footer">
              <i className="fas fa-envelope"></i>
              <a href="mailto:makahmedics@gmail.com">makahmedics@gmail.com</a>
            </div>
            <div className="contact-info-item-footer">
              <i className="fas fa-phone-alt"></i>
              <div>
                <a href="tel:+255778900681">0778 900 681</a> / <a href="tel:+255779900682">0779 900 682</a>
              </div>
            </div>
             <div className="contact-info-item-footer">
              <i className="fas fa-box"></i>
              <span>S.L.P 999, Dar es Salaam</span>
            </div>
          </div>
        </div>

        {/* --- Separator Line --- */}
        <hr className="footer-separator" />
        <div className="footer-bottom">
          <div className="footer-column">
            <h4>Quick Links</h4>
            <ul className="footer-links">
              <li><Link to="/">Home</Link></li>
              <li><Link to="/about">About Us</Link></li>
              <li><Link to="/products">All Products</Link></li>
              <li><Link to="/contact">Contact Us</Link></li>
            </ul>
          </div>

          <div className="footer-column">
            <h4>Our Services</h4>
            <ul className="footer-links">
                <li><Link to="/services/maintenance-repair">Maintenance & Repair</Link></li>
                <li><Link to="/services/consultation-training">Consultation & Training</Link></li>
                <li><Link to="/services/managed-supply">Managed Supply</Link></li>
            </ul>
          </div>

          <div className="footer-column">
            <h4>Connect With Us</h4>
            <div className="footer-social-links">
              <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" aria-label="Instagram">
                <i className="fab fa-instagram"></i>
              </a>
              <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" aria-label="Facebook">
                <i className="fab fa-facebook-f"></i>
              </a>
              <a href="https://wa.me/255769880769" target="_blank" rel="noopener noreferrer" aria-label="WhatsApp">
                <i className="fab fa-whatsapp"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
      <div className="footer-copyright">
       <p>
         © {new Date().getFullYear()} Makah Medics. All Rights Reserved.
          {' | '}<Link to="/privacy-policy">Privacy Policy</Link>
          {' | '}<Link to="/terms-and-conditions">Terms & Conditions</Link>
          {' | '}
          <button
            type="button"
            className="footer-cookie-btn"
            onClick={() => window.dispatchEvent(new CustomEvent('makah:open-cookie-settings'))}
          >
            Cookie Settings
          </button>
          {' | '}
          <button
            type="button"
            className="footer-cookie-btn footer-viewmode-btn"
            onClick={toggleViewMode}
            title="Switch between Mobile and Desktop layout"
          >
            <i className={`fas ${viewportMode === 'desktop' ? 'fa-mobile-alt' : 'fa-desktop'}`}></i>{' '}
            {viewportMode === 'desktop' ? 'Switch to Mobile View' : 'Desktop View'}
          </button>
          {' | '}<a href="https://wa.me/255654548423" target="_blank" rel="noopener noreferrer">Maintained by Nyigs Co. Ltd.</a>
       </p>
      </div>
    </footer>
  );
};

export default Footer;